<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-warning shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-10">
                <h1 class="display-2 text-white">Meet the 2019-2020 Executive Team</h1>
                    <br />
                <div class="row">
                    <div class="col-md-7 col-lg-4 mb-6 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/team/CarrieLu.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 500px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Carrie Lu</span>
                                    <small class="h6 text-muted">President</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 col-lg-4 mb-6 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/team/JennyFan.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 500px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Jenny Fan</span>
                                    <small class="h6 text-muted">VP of Operations</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                  <div class="col-md-7 col-lg-4 mb-6 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/team/AnnieLi.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 500px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Annie Li </span>
                                    <small class="h6 text-muted">VP of Public Relations</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                  <div class="col-md-7 col-lg-4 mb-6 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/team/NehaNerevetla.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 500px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Neha Nerevetla</span>
                                    <small class="h6 text-muted">Operations Coordinator</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                  <div class="col-md-7 col-lg-4 mb-6 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/team/PadenaRasouli.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 500px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Padena Rasouli</span>
                                    <small class="h6 text-muted">Operations Coordinator</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 col-lg-4 mb-6 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/team/SuviCandra.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 500px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Suvi Candra</span>
                                    <small class="h6 text-muted">Public Relations Officer</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                  <div class="col-md-7 col-lg-4 mb-6 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/team/AngelaZhang.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 500px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Angela Zhang</span>
                                    <small class="h6 text-muted">Public Relations Officer</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                  <div class="col-md-7 col-lg-4 mb-6 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/team/FionZheng.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 500px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Fion Zheng</span>
                                    <small class="h6 text-muted">Communications Officer</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 col-lg-4 mb-6 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/team/ShiroPuwa.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 500px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Shirothie Puwaneswaran</span>
                                    <small class="h6 text-muted">Treasurer</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                  <div class="col-md-7 col-lg-4 mb-6 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/team/PhoenixFan.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 500px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Phoenix Fan</span>
                                    <small class="h6 text-muted">Junior Executive</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                </div>
              </div>
            </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>

<style scoped>
img {
  float: right;
}
</style>
